import { useMutation } from "@tanstack/react-query"

import { useApi, useAuth } from "../../hooks"

export const useCreateSamlUserMutation = () => {
  const { api } = useApi({throwIfError: true})
  const { userToken } = useAuth()

  const mutation = useMutation({
    mutationKey: ['create-saml-user'],
    mutationFn: (payload: {referrer_utm_source: string}) => {
      return api({
        token: userToken,
        route: "/create-saml-user/",
        method: "POST",
        payload,
      })
    }
  })

  return { mutation }
}